import { isObjectLike } from './isObjectLike';

export const isObjectEmpty = (obj: unknown) =>
  isObjectLike(obj) && Object.keys(obj as Record<string, unknown>).length === 0;
